import cx from 'classnames';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { CatHeading } from '@blocks-react/components/Heading';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS, STATUS } from '@app/constants/commonConstants';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
import { CatAccordion } from '@blocks-react/components/Accordion';
import { CatAccordionPanel } from '@blocks-react/components/AccordionPanel';
import { CatButton } from '@blocks-react/components/Button';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import WrapperContainer from '@app/components/common/WrapperContainer';
import SearchOptions from '@app/components/pages/account/saved-list/SearchOptions';
import CreateListModal from '@app/components/pages/account/saved-list/CreateListModal';
import SavedListTableContainer from '@app/components/pages/account/saved-list/SavedListTableContainer';
import 'blocks-web-components/dist/bedrock/bedrock.css';

const ShoppingCartLinks = () => {
  const [t] = useTranslation();
  const MD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const savedListsStatus = useSelector(s => s.account?.savedListsStatus);
  const isCustomerSupportSharedCartListsEnabled =
    useSelector(s => s?.featureFlag?.PCC_CustomerSupportSharedCartLists) ||
    false;
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const isSavedListFailed = savedListsStatus === STATUS.REJECTED;
  let shouldExpandAccordionPanel = false;

  const listPageVerbiage = () => {
    if (isCustomerSupportSharedCartListsEnabled) {
      return (
        <>
          {t('SHARED_CART_LISTS_CSRS_TOP_VERBIAGE')}
          <br />
          {t('SHARED_CART_LISTS_CSRS_BOTTOM_VERBIAGE')}
        </>
      );
    }

    return t('CART_LIST_PAGE_VERBIAGE');
  };

  if (isCustomerSupportSharedCartListsEnabled) {
    shouldExpandAccordionPanel = true;
  }

  return (
    <div className="py-md-3 my-5">
      <CatLayoutContainer>
        {isSavedListFailed && (
          <div className="pb-3">
            <CatInlineNotification
              heading={t('UNKNOWN_ERROR_MESSAGE')}
              variant="error"
            >
              <CatIconWarningCircle slot="before" />
            </CatInlineNotification>
          </div>
        )}
        <div
          className={cx(
            styles['shopping-cart-links'],
            'd-flex justify-content-between align-items-center'
          )}
        >
          <CatHeading
            variant={MD ? 'headline' : 'headline-lg'}
            decorator
            styleModifier="--cat-font-family-secondary"
          >
            {t('CART_LIST_PAGE_TITLE')}
          </CatHeading>
          <CatButton
            styleModifier="--cat-font-family-secondary --cat-fw-semibold"
            onClick={() => setShowCreateListModal(true)}
          >
            {t('REQUISITIONLIST_ADD_NEW')}
          </CatButton>
        </div>
        <CatTextPassage size="sm">
          <p className="mt-3 pt-1 mb-4 pb-2">{listPageVerbiage()}</p>
        </CatTextPassage>
        <CatAccordion singlePanelOnly={true} size="lg">
          <CatAccordionPanel
            isActive={shouldExpandAccordionPanel}
            className="cat-u-padding-bottom-xl"
          >
            <div
              slot="header"
              className="text-capitalize cat-u-theme-typography-title"
            >
              {t('APPROVAL_BTN_TOGGLE_SEARCH')}
            </div>
            <SearchOptions />
          </CatAccordionPanel>
        </CatAccordion>

        <WrapperContainer>
          <CreateListModal
            setShowModal={setShowCreateListModal}
            showModal={showCreateListModal}
            isCSRPage={true}
          />
        </WrapperContainer>

        <SavedListTableContainer
          openCreateListModal={() => setShowCreateListModal(true)}
        />
      </CatLayoutContainer>
    </div>
  );
};

export default ShoppingCartLinks;
